module.exports = __webpack_public_path__ + "img/52.69c4d261.png";